import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { BaseComponent } from 'src/app/_base/base.component';
import { UserStatuses, UsersTypes } from 'src/app/_enums';
import { GridActions, GridOperations } from 'src/app/_enums/grid-actions.enum';
import { GridPaginator } from 'src/app/_models';
import { UserBasicInformation } from 'src/app/_models/users/user-basic-information';
import { Section } from 'src/app/templates/models/section.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-grid',
  templateUrl: './user-grid.component.html',
  styleUrls: ['./user-grid.component.scss']
})
export class UserGridComponent extends BaseComponent implements OnInit, AfterViewInit, AfterContentInit {
  gridActions = GridActions;
  gridOperations = GridOperations;
  showedColumns: any[] = [];
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: false,
    suppressScrollY: true
  };

  @Input('userType')
  userType: number;
  userTypes = UsersTypes;
  @Input('totalRecords')
  totalRecords: number;
  @Input('isSelectSection')
  isSelectSection: boolean;
  @Output('actionEmitter')
  actionEmitter = new EventEmitter();
  @Output('operationEmitter')
  operationEmitter = new EventEmitter();
  @Input('dataSource')
  dataSource: UserBasicInformation[];
  dataToBind = new MatTableDataSource<UserBasicInformation>(this.dataSource);
  selection = new SelectionModel(true, []);
  @Output('PaginationChange')
  gridPagination = new EventEmitter<GridPaginator>();
  @Input('gridPaginator')
  gridPaginator: GridPaginator;

  @Input('showCreatedOnColumn')
  showCreatedOnColumn: boolean;

  @Input('showSelectAll')
  showSelectAll: boolean = true;

  // paging emitter
  @Output()
  page: EventEmitter<PageEvent>;
  // statuses icons
  Active = 9;
  environment = environment;
  defaultImgUrl: string = '../../assets/Images/users/default-user.jpg';
  imgUrls = {
    1: '/assets/Icons/new.png',
    2: '/assets/Icons/registered.png',
    3: '/assets/Icons/inCompleted.png',
    4: '/assets/Icons/movement.png',
    5: '/assets/Icons/dropOut.png',
    6: '/assets/Icons/blocked.png',
    7: '/assets/Icons/denied.png',
    8: '/assets/Icons/deleted.png',
    9: '/assets/Icons/active.png',
    10: '/assets/Icons/Almuni.png'
  };
  //

  displayedColumns: string[];
  showAndHide: string[] = [
    'Common.SelectAll',
    'KendoGridColumns.ProfilePicture',
    // 'KendoGridColumns.Name',
    'UserModule.UsersData.AdmissionNo',
    'Email',
    'UserModule.UsersData.address',
    'UserModule.UsersData.CreatedOn'
    // 'KendoGridColumns.Actions'
  ];
  //

  userStatuses = UserStatuses;
  selectedRows: UserBasicInformation[] = [];
  operation: number = -1;
  sections: Section[] = [];
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  isSelectedAll: boolean = false;
  // @ViewChild(MatSort)
  // set matSort(ms: MatSort) {
  //   this.sort = ms;
  //   this.setDataSourceAttributes();
  // }

  // @ViewChild(MatPaginator)
  // set matPaginator(mp: MatPaginator) {
  //   this.paginator = mp;
  //   this.setDataSourceAttributes();
  // }

  // setDataSourceAttributes() {

  //   this.dataToBind.paginator = this.paginator;
  //   this.dataToBind.sort = this.sort;

  //   if (this.paginator && this.sort) {
  //     this.applyFilter('');
  //   }
  // }
  // applyFilter(filterValue: string) {
  //   filterValue = filterValue.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  //   this.dataToBind.filter = filterValue;
  // }
  //
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    // let numRows = this.dataToBind.data.length;
    const numRows = this.dataToBind.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.dataToBind.data.forEach(row => this.selection.select(row));
    if (this.selection) {
      this.selectedRows = [];
      this.selection.selected.length > 0
        ? this.selection.selected.map(i => {
            this.selectedRows.push(i);
          })
        : (this.selectedRows.length = 0);
    }
  }
  constructor(private changeDetectorRefs: ChangeDetectorRef) {
    super();
  }
  ngOnInit() {
    if (this.showSelectAll)
      this.displayedColumns = ['SelectAll', 'ProfilePicture', 'fullNameEn', 'AdmissionNo', 'Email', 'Contact', 'Actions'];
    else {
      this.displayedColumns = [
        // 'SelectAll',
        'ProfilePicture',
        'fullNameEn',
        'AdmissionNo',
        'Email',
        'Contact',
        'Actions'
      ];
    }
    this.dataToBind = new MatTableDataSource<UserBasicInformation>(this.dataSource);
    this.changeDetectorRefs.detectChanges();
    this.showedColumns = [...this.showAndHide];
  }
  ngAfterViewInit(): void {
    this.dataToBind.sort = this.sort;
  }

  ngAfterContentInit(): void {
    if (this.showCreatedOnColumn) {
      this.displayedColumns.splice(4, 1, 'createdOn');
    }

    if (!this.showCreatedOnColumn) {
      this.showAndHide.splice(5, 1);
    }
  }

  actionsEmitter(element: any, action: GridActions): void {
    this.actionEmitter.emit({ element: element, action: action });
  }
  operationsEmitter() {
    if (this.operation)
      if (this.selectedRows.length > 0) {
        this.operationEmitter.emit({
          elements: this.selectedRows,
          action: this.operation
        });
      }
    setTimeout(() => {
      this.operation = -1;
    }, 50);
  }

  addToSelectedList(checked: boolean, row: UserBasicInformation): void {
    if (checked) this.selectedRows.push(row);
    else this.selectedRows.splice(this.selectedRows.indexOf(row), 1);
  }

  getAcademicLabel(element: UserBasicInformation) {
    if (this.settings.rtl) return `${element.className} - ${element.sectionName}`;
    else return `${element.classNameEn} - ${element.sectionNameEn}`;
  }

  // init paging
  onPageChanged(e) {
    this.gridPagination.emit((this.gridPaginator = { pageIndex: e.pageIndex, pageSize: e.pageSize }));
  }
  selectAll() {
    this.isSelectedAll = !this.isSelectedAll;
    this.masterToggle();
  }
}
